import {useEffect, useState} from 'react';
import {Box} from '@mui/material';
import MyTablesAndTicketsTable from './MyTablesAndTicketsTable';
import Loader from '@/shared/components/Loader';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getUserSelector, getUsersTablesAndTickets} from '@/store/user';
import {MyTablePageStyle} from './MyTablePageStyle.styles';
import {getCurrentEventSelector} from '@/store/organization-event';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';

const MyTablePage = () => {
  const dispatch = useAppDispatch();

  const user = useAppSelector(getUserSelector);
  const event = useAppSelector(getCurrentEventSelector);
  const [isLoading, setIsLoading] = useState(false);

  const getUseTables = async () => {
    if (!user || !event) return;
    try {
      setIsLoading(true);

      await dispatch(getUsersTablesAndTickets({userId: user.id, eventId: event.id})).unwrap();
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (event) {
      getUseTables();
    }
  }, [event]);

  return (
    <Box sx={MyTablePageStyle.wrapper}>
      {isLoading ? (
        <Loader sx={MyTablePageStyle.loader} size={50} />
      ) : (
        <Box>
          <MyTablesAndTicketsTable />
        </Box>
      )}
    </Box>
  );
};

export default MyTablePage;
